import React from 'react'
import ItemMovieAccess from '../ItemsAccess/ItemMovieAccess'

const FilterResultsListAccess = ({
    items,
    queryStringValues,
    activeCinema,
    dayFilters
}) => (
    <div>
        <ul className="access-filter-results">
            {items.map(itemId => {
                const htmlId = `${itemId}_overview`

                return (
                    <li key={htmlId}>
                        <ItemMovieAccess 
                            key={htmlId}
                            id={itemId}
                            htmlId={htmlId}
                            filterType={null}
                            filterValue={null}
                            currentCinemaId={activeCinema}
                            queryStringValues={queryStringValues}
                            overviewFilterIgnoreOnPerformances={null}
                            dayFilters={dayFilters}
                        />
                    </li>
                )
            })}
        </ul>
    </div>
)

export default FilterResultsListAccess